<template>
  <section class="content">
    <div class="row center-block">
      <!--<h2>Data tables</h2>-->
      <div class="col-md-12">
        <div class="box">
          <!-- /.box-header -->
          <div class="row">
            <h3 class="text-center" style="margin-top: 2em; margin-bottom: 1em;">
              主帳號資訊
            </h3>
            <div class="box-body form-left">
              <div>
                <div class="input-group ">
                  <span class="input-group-addon min-w-220 text-align-left">編號</span>
                  <div class="form-control form-info">
                    {{memberInfo.user_no}}
                  </div>
                </div>
                <br />
              </div>
              <div>
                <div class="input-group ">
                  <span class="input-group-addon min-w-220 text-align-left">暱稱</span>
                  <div class="form-control form-info">
                    {{memberInfo.nickname}}
                  </div>
                </div>
                <br />
              </div>
              <div>
                <div class="input-group ">
                  <span class="input-group-addon min-w-220 text-align-left">手機</span>
                  <div class="form-control form-info">
                    {{memberInfo.phone}}
                    <span v-if="memberInfo.is_phone_valid == 0" class="label label-danger">未通過</span>
                    <span v-if="memberInfo.is_phone_valid == 1"  class="label label-success">已通過</span>
                  </div>
                </div>
                <br />
              </div>
            </div>
            <div class="box-body form-center min-h-640" v-if="getRoleType === 99">
              <br>
              <h3 class="text-center">
                綁定副帳號資訊
              </h3>
              <!--主副帳號的優惠券都顯示-->
              <div v-if="integrateMemberList.length">
                <div class="col-xs-12">
                  <div class="col-sm-12 table-responsive p-x-0">
                    <table aria-describedby="example1_info" role="grid" id="example1" class="table table-bordered table-striped dataTable">
                      <thead>
                      <tr role="row">
                        <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">#</th>
                        <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">類型</th>
                        <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">暱稱</th>
                        <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">品牌</th>
                        <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">整合時間</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr class="even" role="row" v-for="(mem, index) in integrateMemberList">
                        <td>
                          {{index + 1}}
                        </td>
                        <td>
                          <span v-if="mem.account_type == 1"><img class="img-login-type img-round" src="/static/img/icon/phone.svg"></span>
                          <span v-if="mem.account_type == 2"><img class="img-login-type img-round" src="/static/img/icon/fb.png"></span>
                          <span v-if="mem.account_type == 3"><img class="img-login-type img-round" src="/static/img/icon/google.png"></span>
                          <span v-if="mem.account_type == 4"><img class="img-login-type img-round" style="margin-right: 8px;" src="/static/img/icon/line.png"></span><span v-if="memberInfo.create_account_owner_type == 2 && memberInfo.create_account_type == 4">({{memberInfo.create_account_owner_brand_name}})</span><span v-else-if="memberInfo.create_account_owner_type == 1 && memberInfo.create_account_type == 4">(你訂)</span>
                          <span v-if="mem.account_type == 5"><img class="img-login-type img-round" src="/static/img/icon/jkos.svg"></span>
                        </td>
                        <td>
                          {{mem.user_name}}
                        </td>
                        <td>
                          {{mem.provider_owner_name}}
                        </td>
                        <td>
                          {{mem.integrate_time}}
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div v-else>
                無整合帳號
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
export default {
  data () {
    return {
      memberInfo: {},
      roleType: 99,
      integrateMemberList: [],
      // page
      count: 20,
      total: 0,
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      stateType: 'avail',
      // select
      brandSelect: {
        label: '== 品牌 ==',
        vlaue: 0
      },
      storeSelect: {
        label: '== 門市 ==',
        vlaue: 0
      },
      brandBrief: [],
      storeBrief: []
    }
  },
  methods: {
    getList (index) {
      this.gteCouponSummary(index)
    },
    clickPage (index) {
      this.tableIndex = index
      this.getList(index)
    },
    clickGroup (type) {
      if (type === 'left' && this.pageGroup !== 1) {
        this.pageGroup = this.pageGroup - 1
        this.tableIndex = this.groupAmount * this.pageGroup
        this.clickPage(this.tableIndex)
      } else if (type === 'right' && this.pageGroup !== Math.ceil(this.pageAmount / this.groupAmount)) {
        this.pageGroup = this.pageGroup + 1
        this.tableIndex = this.groupAmount * (this.pageGroup - 1) + 1
        this.clickPage(this.tableIndex)
      }
    },
    clickEnd (type) {
      if (type === 'pre') {
        this.clickPage(1)
        this.pageGroup = 1
      } else if (type === 'forward') {
        if (this.pageAmount) this.clickPage(this.pageAmount)
        else this.clickPage(1)
        this.pageGroup = Math.ceil(this.pageAmount / this.groupAmount)
      }
    },
    isActive (index) {
      if (this.tableIndex === index) return true
      else return false
    },
    pageShow (index) {
      var num = index / this.groupAmount
      if (this.pageGroup - 1 < num && num <= this.pageGroup) return true
      else return false
    },
    getSourceMethodName (method) {
      switch (method) {
        case 'order': return '訂單'
        case 'transfer': return '轉贈'
        case 'register': return '註冊'
        case 'other': return '其他'
      }
    },
    getDate (datetime) {
      return moment(datetime, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD')
    },
    getMemberById () {
      var self = this
      if (this.$route.params.user_id) {
        var url = '/shopper/' + this.$route.params.user_id
        this.loginType = 99
        this.getDataH('get', url, null, function (response) {
          if (response.data.status === 200) {
            self.memberInfo = response.data.shopper_info
            self.integrateMemberList = self.memberInfo.integrated_shopper_list
            if (self.getRoleType === 99) self.getList(1)
          }
        })
      }
    },
    getBrandMemberById () {
      var self = this
      if (this.$route.params.user_id) {
        var url = '/shopper/' + this.$route.params.user_id + '/basic'
        this.loginType = 99
        this.getDataH('get', url, null, function (response) {
          if (response.data.status === 200) {
            self.memberInfo = response.data.shopper_info
          }
        })
      }
    },
    getBrandBrief () {
      var self = this
      self.brandBrief = [{ label: '== 品牌 ==', vlaue: 0 }]
      var url = '/brand/listBrief?is_delete=0&is_opening=1&list_sort=name ASC'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var bList = response.data.list
          for (let i = 0; i < bList.length; i++) {
            let obj = {label: bList[i].name, value: bList[i].brand_id}
            self.brandBrief.push(obj)
          }
        }
      })
    },
    getStoreBrief (brandId) {
      console.log('getStoreBrief | UpgradeMemberInfo')
      var self = this
      self.storeBrief = [{ label: '== 門市 ==', vlaue: 0 }]
      var url = '/brand/' + brandId + '/storeListBrief?status=2&list_sort=name ASC'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list
          for (let i = 0; i < sList.length; i++) {
            let obj = {label: sList[i].name, value: sList[i].store_id}
            self.storeBrief.push(obj)
          }
        }
      })
    },
    changeBrand () {
      this.storeSelect = {
        value: 0,
        label: '== 門市 =='
      }
      if (this.brandSelect.value) this.getStoreBrief(this.brandSelect.value)
      this.getList(1)
    }
  },
  created () {
    this.roleType = parseInt(this.getRoleType, 10)
    if (this.roleType === 99) this.getMemberById()
    else if (this.roleType === 30) this.getBrandMemberById()
    this.getBrandBrief()
  },
  computed: {
    ...mapGetters(['getRoleType']),
    getDataH () {
      return this.$parent.getDataH
    },
    pageAmount () {
      return Math.ceil(this.total / this.count)
    }
  }
}
</script>
<style>
.form-control.form-info {
  border: none;
  border-left: 1px solid #d2d6de;
}
.form-info .label {
  font-size: 15px;
  border-radius: 5px !important;
}
.min-h-640 {
  min-height: 640px;
}
.min-w-220 {
  min-width: 220px;
}
.text-align-left {
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// UpgradeMemberInfo.vue?d1fdb570